import React from 'react'
import { Link } from 'react-router-dom'
import Brightness4Icon from '@material-ui/icons/Brightness4'
import Brightness7Icon from '@material-ui/icons/Brightness7'
import { useTheme } from '../../contexts/ThemeContext'
import '../../styles/dynamic-background.css'
import './LegalDocument.css'

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

const LegalDocument = ({ title, lastUpdated, updatedOn, relatedTo, relatedLabel, children }) => {
  const { theme, toggleTheme } = useTheme()
  const nextTheme = theme === 'light' ? 'dark' : 'light'
  const dated = ISO_DATE.test(updatedOn)

  return (
    <div className='legal-page dynamic-bg'>
      <header className='legal-topbar'>
        <Link to='/' className='legal-brand' aria-label='Quillnote home'>
          <img src='/logo.svg' alt='' className='legal-logo' />
          <span className='legal-wordmark brand-text'>Quillnote</span>
        </Link>
        <button
          type='button'
          className='qn-theme-toggle'
          onClick={toggleTheme}
          aria-label={`Switch to ${nextTheme} mode`}
          title={`Switch to ${nextTheme} mode`}
        >
          {theme === 'light'
            ? <Brightness4Icon style={{ fontSize: 20 }} />
            : <Brightness7Icon style={{ fontSize: 20 }} />}
        </button>
      </header>

      <div className='legal-scroll'>
        <main className='legal-main'>
          <article className='legal-card' aria-labelledby='legal-title'>
            <header className='legal-header'>
              <h1 id='legal-title' className='legal-title'>{title}</h1>
              <p className='legal-updated'>
                <strong>Last updated:</strong>{' '}
                {dated ? <time dateTime={updatedOn}>{lastUpdated}</time> : lastUpdated}
              </p>
            </header>

            <div className='legal-body'>
              {children}
            </div>

            <footer className='legal-footer'>
              <p className='legal-related'>
                Also see our <Link to={relatedTo}>{relatedLabel}</Link>.
              </p>
              <Link to='/' className='qn-btn qn-btn-primary legal-home'>
                Back to Home
              </Link>
            </footer>
          </article>
        </main>
      </div>
    </div>
  )
}

export default LegalDocument
